import { render, staticRenderFns } from "./additionalServicesList.vue?vue&type=template&id=f6669b8e&scoped=true&"
import script from "./additionalServicesList.vue?vue&type=script&lang=js&"
export * from "./additionalServicesList.vue?vue&type=script&lang=js&"
import style0 from "./additionalServicesList.vue?vue&type=style&index=0&id=f6669b8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6669b8e",
  null
  
)

export default component.exports